// extracted by mini-css-extract-plugin
export default {"templatesWrapper":"ReportsTemplates_templatesWrapper__74eP2","filters":"ReportsTemplates_filters__RL0sB","templatesCards":"ReportsTemplates_templatesCards__cCSVM"};